export enum EmployerDriversLicense {
  Yes = 'yes',
  No = 'no',
  YesWithCar = 'driverslicense_and_car',
}

export const EMPLOYER_REQUIRE_DRIVERS_LICENSE_VALUES = [EmployerDriversLicense.Yes, EmployerDriversLicense.YesWithCar];

export const EMPLOYER_DRIVERS_LICENSE_TRANSLATIONS = {
  [EmployerDriversLicense.YesWithCar]: 'Führerschein + Auto',
  [EmployerDriversLicense.No]: 'Nein',
  [EmployerDriversLicense.Yes]: 'Ja',
};
